import {UI} from "../../stem-core/src/ui/UI";

import {styleRuleCustom, styleRuleInherit} from "../../stem-core/src/ui/UI";
import {Route, Router, TerminalRoute} from "../../stem-core/src/ui/Router";
import {GlobalStyleSheet} from "../GlobalStyleSheet";
import {iFrameBlinkService} from "../services/IFrameBlinkService";
import {IndexExpanded} from "./pages/index-expanded/IndexExpanded";
import {IFrameMessages} from "../../blink-sdk/messaging/IFrameMessages";
import {iFrameConnection} from "../services/IFrameConnection";
import {Image} from "../../stem-core/src/ui/UIPrimitives";
import {iFrameState} from "../services/IFrameState";
import {WidgetRouting} from "./WidgetRouting";
import {authService, userService} from "../../client/connection/Services";
import {WidgetCloseButton} from "./WidgetCloseButton";
import {AuthToken} from "../../client/connection/AuthToken";
import {addScrimListeners, widgetAnimation} from "./WidgetAnimation";
import {BlinkGlobal, isSmallScreen} from "../UtilsLib";
import {unwrapArray} from "../../stem-core/src/base/Utils";
import {
    IFRAME_APP_TYPE,
    POPUP_GATE_TRANSITION_TIME,
    WIDGET_TRANSITION
} from "../../blink-sdk/Constants";
import {WidgetRoutes} from "./WidgetRoutes";
import {AuthService} from "../../client/connection/services/AuthService";
import {apiUpdateUserMerchantActivity} from "../../client/state/UserProfileStore";
import {iFrameMerchantService} from "../services/IframeMerchantService";
import {App} from "../App";
import {setToastClass} from "../Utils";
import {PanelToast} from "../panel/PanelToast";
import {Dispatcher} from "../../stem-core/src/base/Dispatcher";
import {iFrameUserDataService} from "../services/IFrameUserDataService";
import {iFramePaymentsProcessor} from "../services/IFramePaymentsProcessor";


class WidgetGlobalStylesheet extends GlobalStyleSheet {
    @styleRuleCustom({selector: "body"})
    body = {
        userSelect: "text",
        pointerEvents: "none",
        ">*": {
            pointerEvents: "all",
        },
        height: "100%",
        width: "100%",
        margin: 0,
        fontFamily: this.themeProps.MERCHANT_FONT_FAMILY,
        " *": {
            userSelect: () => isSmallScreen() ? "none" : "auto",
            "-webkit-tap-highlight-color": "transparent",
        },
        // widget app node
        ">div:nth-child(3)": {
            height: "100%",
        },
        // global container
        ">div:nth-child(3)>:first-child": {
            minHeight: "100% !important",
            height: "100% !important",
        },
        position: "absolute",
        overflow: "hidden",
        // These are for Safari border bugs during animations.
        "-webkit-backface-visibility": "hidden",
        "-moz-backface-visibility": "hidden",
        "-webkit-transform": "translate3d(0, 0, 0)",
        "-moz-transform": "translate3d(0, 0, 0)",
        color: this.themeProps.MERCHANT_TEXT_PRIMARY_COLOR,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_NORMAL,
        lineHeight: this.themeProps.GENERAL_LINE_HEIGHT,
    };

    @styleRuleInherit
    html = {
        userSelect: "none",
        fontSize: "10px",
        overflow: "hidden !important",
        width: "100%",
        height: "100%",
        transition: POPUP_GATE_TRANSITION_TIME + "ms background ease",
    };

    @styleRuleInherit
    a = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRuleCustom({selector: "b"})
    b = {
        fontWeight: this.themeProps.MERCHANT_FONT_WEIGHT_BOLD,
    };

    @styleRuleInherit
    allInputs = {
        fontFamily: this.themeProps.MERCHANT_FONT_FAMILY,
    };
}

export class WidgetApp extends App {
    constructor(...args) {
        super(...args);

        BlinkGlobal.appInstance = this;
        this.widgetStyle = {};
        this.animationStyleDispatcher = new Dispatcher();
        this.attachListener(this.animationStyleDispatcher, style => {
            this.widgetStyle = {...this.widgetStyle, ...style};
            if (this.node && style.bottom) {
                this.setStyle(this.widgetStyle);
            }
        });

        setToastClass(PanelToast);
        widgetAnimation.initListeners();
        iFrameConnection.addListener(IFrameMessages.REPOSITION_WIDGET, () => {
            widgetAnimation.repositionWidget();
        });

        // Send merchant activity updates for a logged in user.
        this.sendMerchantActivity();
        WidgetRouting.initRoutesLogic();
        this.initRouter(WidgetRoutes.INDEX_COLLAPSED);
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.setStyle({
            overflow: "hidden",
            boxShadow: "",
            background: "transparent",
            opacity: 1,
            position: "absolute",
            transition: "width " + WIDGET_TRANSITION + ", height " + WIDGET_TRANSITION + ", bottom "
                + WIDGET_TRANSITION,
            ...((iFrameState.widgetVisible && !iFrameState.activePanel) ? {
                ...(widgetAnimation.collapsed ? {
                    bottom: iFrameState.positionBottom,
                    width: "52px",
                    height: "52px",
                } : {}),
                display: "initial",
            } : {
                display: "none",
            }),
        });
        attr.setStyle(this.widgetStyle);
    }

    sendMerchantActivity() {
        let lastMerchantActivityToken = "";

        const updateMerchantActivity = () => {
            if (authService.isAuthenticated() && iFrameUserDataService.getMerchantUser()
                && lastMerchantActivityToken !== authService.token.toString()) {
                apiUpdateUserMerchantActivity(iFrameMerchantService.merchantId);
                lastMerchantActivityToken = authService.token.toString();
            }
        };
        authService.addListener(AuthToken.EventTypes.LOGIN, updateMerchantActivity);
        iFrameState.addUpdateListener(updateMerchantActivity);
        updateMerchantActivity();
    }

    static initializeGlobalStyle() {
        WidgetGlobalStylesheet.initialize();
    }

    getRoutes() {
        return new Route([], null, [
            new TerminalRoute([], IndexExpanded, [], "")
        ]);
    }

    getContainer() {
        return (
            <div style={{height: "100%"}}>
                {this.getRouter()}
                {this.getStaticInvisibleElements()}
                {isSmallScreen() ? <WidgetCloseButton testId={"modalCloseButton"}/> : <span/>}
            </div>
        );
    }

    // Render these invisible elements so the fetches execute earlier.
    getStaticInvisibleElements() {
        const merchant = iFrameMerchantService.getMerchant();

        // This is so that the elements are under no circumstance visible.
        return (
            <div style={{opacity: "0", pointerEvents: "none", zIndex: -1, position: "absolute", top: -1e4, left: -1e4}}>
                {merchant ? <Image src={merchant.wideLogoUrl} /> : null}
                <div style={{fontStyle: "italic"}}>a</div>
                <div style={{fontWeight: "bold"}}>a</div>
                <div>a</div>
            </div>
        );
    }

    initRouter(initialPage) {
        authService.addListener(AuthService.EventTypes.CLEAR_CURRENT_INFO, () => {
            Router.changeURL(WidgetRoutes.INDEX_COLLAPSED);
        });

        Router.useLocalHistory = true;
        Router.localHistory = ["/" + initialPage];
        // TODO @cleanup don't change the prototype
        Router.prototype.setActive = function(element) {
            if (this.activeChild === element) {
                return;
            }
            const oldActiveChild = this.activeChild;
            if (element) {
                this.activateChild(element);
            }
            if (oldActiveChild) {
                this.deactivateChild(oldActiveChild);
            }
            this.updateActiveChild(element);
        }
        let firstRouteChange = true;
        Router.globalSetURL = function (url) {
            const urlParts = unwrapArray(url);
            const page = this.getPageToRender(urlParts);
            const activePage = this.getActive();

            if (!activePage) {
                this.setActive(page);
            }

            if (activePage && activePage !== page) {
                activePage.dispatch("urlExit");
            }

            if (!page) {
                return;
            }

            if (firstRouteChange && urlParts[0] === WidgetRoutes.INDEX_COLLAPSED) {
                firstRouteChange = false;
            }

            this.setWidgetURL(url);
            if (authService.isAuthenticated()) {
                if (iFrameState.activePanel) {
                    return;
                }
                if (!widgetAnimation.collapsed) {
                    Object.assign(document.documentElement.style, {
                        background: WidgetGlobalStylesheet.getInstance().themeProps.MERCHANT_SCRIM_BACKGROUND,
                    });
                } else {
                    Object.assign(document.documentElement.style, {
                        background: "transparent",
                    });
                }
            }
        }
    }

    onMount() {
        super.onMount();
        addScrimListeners(IFRAME_APP_TYPE.widget);
        iFrameBlinkService.init();
        iFramePaymentsProcessor.init();
        iFrameConnection.sendToSDK(IFrameMessages.WIDGET_DATA_LOADED);

        let activePanel = false;
        iFrameState.addUpdateListener(() => {
            if (!iFrameState.widgetVisible) {
                return;
            }
            if (!activePanel && iFrameState.activePanel) {
                Router.changeURL(WidgetRoutes.INDEX_COLLAPSED);
            }
            activePanel = iFrameState.activePanel;
            this.redraw();
        });
        authService.onAuthenticationChange(() => {
            if (authService.isAuthenticated()) {
                userService.ensureUserDataRequested(() => IndexExpanded.instance.redraw());
                widgetAnimation.repositionWidget();
            }
        });
    }
}
